export default __webpack_public_path__ + "static/media/right-arrow.4b75dfa8.svg";